import ReactMarkdown from "react-markdown";
import rehypeRaw from 'rehype-raw'
import { executeHooks } from "../../utils/hooks";
import { useEffect } from "react";

const RichContent = ({ html, content, ...rest }) => {

  useEffect(() => {
    if (html && content) {
      executeHooks(content);
    }
  }, []);

  if (html) {
    return <ReactMarkdown rehypePlugins={[rehypeRaw]} children={content} />
  } else {
    return <ReactMarkdown {...rest} components={{p: 'span'}}>{content}</ReactMarkdown>;
  }

}

export default RichContent;